// ABOUTME: W1 — submit a transcript/Q&A for ingestion and poll the resulting job.

import { apiClient } from './client'

export interface TranscriptMetadata {
  interviewee_name: string
  group: string
  institution: string
  interview_name: string
  interview_date?: string
  facilitator?: string
  notetaker?: string
  recording_link?: string
}

export interface Job {
  job_id: string
  kind: string
  status: 'queued' | 'running' | 'completed' | 'failed'
  created_by: string
  created_at: string
  completed_at: string | null
  /** interview_id the job acts on (null for ingestion jobs — no id until success) */
  target_ref: string | null
  /** human name for the target — survives failed ingests */
  target_label: string | null
  result: Record<string, any> | null
  error: string | null
}

/** Own jobs (admins: all) — powers the activity panel and row status chips */
export async function listJobs(): Promise<Job[]> {
  const response = await apiClient.get<Job[]>('/api/jobs')
  return response.data
}

export async function ingestTranscript(
  text: string,
  metadata: TranscriptMetadata,
  file?: File
): Promise<{ job_id: string }> {
  const form = new FormData()
  form.append('metadata', JSON.stringify(metadata))
  if (file) form.append('transcript_file', file)
  else form.append('transcript_text', text)
  const { data } = await apiClient.post('/api/ingestion/transcript', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}

export async function getJob(jobId: string): Promise<Job> {
  const { data } = await apiClient.get(`/api/jobs/${jobId}`)
  return data
}
